import { ENTITY } from '../constant';
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { dateFormat } from '../helper/StringUtils';
import { PLATFORM_ALERT } from '../constant/actionTypes';

const apiEndPoint = constants.ADMIN_URL;

export const getPlatformAlertsList = () => (dispatch) => {
  const query = `${constants.API.PLATFORM_ALERTS}`;

  dispatch({
    payload: [],
    type: PLATFORM_ALERT.DATA.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      const {
        rows = [],
        count = 0,
      } = response.data.response;

      const responseData = rows && rows.length ? rows.map((data) => (
        {
          ...data,
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
          created_at: dateFormat(data.createdAt),
        })) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: PLATFORM_ALERT.DATA.SUCCESS,
      });
      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: PLATFORM_ALERT.DATA.ERROR,
      });
    });
};

export const doPlatformAlertCreate = (data) => httpservice()
  .post(`${apiEndPoint}${constants.API.PLATFORM_ALERT}`, data)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doPlatformAlertUpdate = (Id, data) => {
  const endPointUri = constants.API.PLATFORM_ALERT_BY_ID.replace(ENTITY.PLATFORM_ALERT_ID, Id);
  return httpservice()
    .put(endPointUri, data)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const doPlatformAlertDelete = (id) => {
  const endPointUri = constants.API.PLATFORM_ALERT_BY_ID.replace(ENTITY.PLATFORM_ALERT_ID, id);
  return httpservice()
    .delete(endPointUri)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};
